import { render, staticRenderFns } from "./ServiceOneItems.vue?vue&type=template&id=001b4834&scoped=true&"
import script from "./ServiceOneItems.vue?vue&type=script&lang=js&"
export * from "./ServiceOneItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001b4834",
  null
  
)

export default component.exports